<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ofo4Fd/images/9781453202258.jpg?1733085643103" alt="This image is the cover for the book Wisdom of the Torah, Wisdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wisdom of the Torah, Wisdom
      </h1>
      <p class="bookDescription body article font2">
        <p> </p><b>Celebrate one of the world’s greatest collections of pure literature</b> In Hebrew, the word <i>Torah</i> means instruction, and throughout thousands of years this collection of writing has offered just that—instruction in the central beliefs of three world religions: Judaism, Christianity, and Islam. But by observing the Torah, or the Hebrew Bible, as a collected work of multiple authors spanning generations, the modern reader can look beyond its fundamental instruction. <i>The Wisdom of the Torah</i> concentrates on the Hebrew Bible as a book of philosophy and literature and offers some of its most powerful and poetic passages, including “The Poems of King David,” “The Parables of King Solomon,” and “The Love Songs of King Solomon.” In these works, readers find many lyrical and timeless reflections on what it means to have faith and to be a member of the human race. This ebook features a new introduction, image gallery, timeline of the Torah and Judaic history, and index of the Books of the Torah.<p> </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        The Wisdom Series
      </h2>
      
      <p class="authorDescription body article"><p>The Torah, or Hebrew Bible, is the cornerstone of Jewish religion and law. The holiest of all books, <i>the Torah</i> originally referred only to the books attributed to Moses. As it appears here, and in most of Judaism today, it encompasses the whole of the Hebrew Bible, as well as Talmudic writings.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60b0872e